module.exports = __webpack_public_path__ + "static/scopriabitareco_experiences_nuovecostruzioni-debaa9371789834511a4dd663ac5a57e.jpg";